import React from 'react';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import HeroSection from 'containers/HeroSection';
import TeamGrid from 'containers/TeamGrid';
import TextGrid from 'components/TextGrid';

import CustomVideo from 'components/CustomVideo';
import useAboutUsData from '../../pageDataHooks/useAboutUsData';

const AboutUs = () => {
  const { contentfulPage: data } = useAboutUsData();
  return (
    <Layout navType="dark" navBgColor="#fff" navLinkType="dark">
      <SEO
        description={data.metaDescription.metaDescription}
        title={data.metaTitle}
        useTitleTemplate={false}
      />

      <HeroSection
        type="small"
        mainTitle={
          <div style={{ color: '#192f54' }}>
            {data.hero_sections[0].primaryTitle}
          </div>
        }
        subTitle={
          <div style={{ color: '#192f54' }}>
            {data.hero_sections[0]?.primaryDescription.primaryDescription}
          </div>
        }
        imageData={data.hero_sections[0]?.image}
        useGracefulImage={true}
      />

      <TextGrid
        data={[
          {
            title: data.whoWhyWhy[0]?.title1,
            description: data.whoWhyWhy[0]?.who.who,
            align: data.whoWhyWhy[0]?.align1,
          },
          {
            title: data.whoWhyWhy[0]?.title2,
            description: data.whoWhyWhy[0]?.why.why,
            align: data.whoWhyWhy[0]?.align2,
          },

          {
            title: data.whoWhyWhy[0]?.title3,
            description: data.whoWhyWhy[0]?.how.how,
            align: data.whoWhyWhy[0]?.align3,
          },
        ]}
        imageData={data.whoWhyWhy[0]?.image}
        useGracefulImage={true}
        showNumbers={true}
      />

      {/* VIDEO SECTION */}
      <CustomVideo
        content={data.videoSection[0]?.description?.description}
        title={data.videoSection[0]?.title}
        titleHighlight=""
        videoId={data.videoSection[0]?.videoId}
        placeholder={data.videoSection[0]?.placeholder}
        useGracefulImage={true}
      />
      {/* /VIDEO SECTION*/}

      <TeamGrid
        title={data.teamGrid[0]?.title}
        description={data.teamGrid[0]?.description?.description}
        data={data.teamGrid[0]?.data
          ?.map(team => {
            return {
              ...team,
              description: team.description.description,
            };
          })
          .reverse()}
      />
    </Layout>
  );
};

AboutUs.propTypes = {};

export default AboutUs;
